var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"download-button",attrs:{"href":_vm.download.src,"download":_vm.download.name,"title":`Descargar ${_vm.download.name} ${_vm.download.version}`}},[_c('iconic',{attrs:{"name":"circle_down"}}),_c('span',{staticClass:"label"},[_vm._v("Descargar")]),_c('span',{staticClass:"version"},[_vm._v(_vm._s(_vm.download.version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }